import {ConfirmationModalBean} from "../../../components/modal/ConfirmationModalBean";

import selectAllComponentTemplate from './selectAllComponent.html';

/**
 * Directive to add master (select all) check box to ng-table
 *
 * Usage:
 *  <script type="text/ng-template" id="groupsHeaderCheckbox.html">
        <select-all-component parent-controller="groupsTableController" row-identifier="groupId"></select-all-component>
    </script>
    N.B. id (e.g. groupsHeaderCheckbox.html) should be unique as it is cached!
 */

/** @ngInject */
export function selectAllComponent() {
    return {
        restrict: 'E',
        scope: {
            parentController: '=',
            rowIdentifier: '@',
            hideSelectAll: '=',
            displayGlobal: '@'
        },
        templateUrl: selectAllComponentTemplate,
        controller: SelectAllController,
        controllerAs: 'selectAllController'
    };
}

// PAGE to select all items on the page, GLOBAL to select all items
export const SELECT_ALL_TYPE = { 'PAGE': 'PAGE', 'GLOBAL': 'GLOBAL' };

export class SelectAllController {
    constructor($scope, $rootScope, Toast, ArsConfig) {
        this.toast = Toast;
        this.$rootScope = $rootScope;
        this.parentController = $scope.parentController;
        this.maxAccounts = ArsConfig.MAX_ACCOUNTS;
        // Master checkbox configuration: the parent controller must have defined this.checkboxes={}
        this.checkboxes = this.parentController.checkboxes;
        this.checkboxes.masterChecked = false; // Select all (master) check box model
        this.checkboxes.checkedCounter = 0; // Number of checked boxes on the current page
        this.checkboxes.rows = {}; // "Global" selected rows i.e. independent from the page
        this.checkboxes.disabled = false; // Is master checkbox enabled?
        this.checkboxes.rowID = $scope.rowIdentifier; // identifier
        this.checkboxes.selectType = SELECT_ALL_TYPE.PAGE;

        this.updateMasterCheckBox = () => {
            if (this.checkboxes.selectType === SELECT_ALL_TYPE.GLOBAL) {
                if (!this.checkboxes.masterChecked) {
                    this.checkboxes.rows = {};
                    this.checkboxes.selectType = SELECT_ALL_TYPE.PAGE
                }

                this.selectAll(this.checkboxes.masterChecked);
            }

            // Is there at least one checked box on any page? Then we check the select all check box
            this.checkboxes.masterChecked = Object.keys(this.checkboxes.rows).some((item) => this.checkboxes.rows[item]);

            // Count the number of checked boxes on the current page
            this.checkboxes.checkedCounter = this.parentController.dataList.filter((item) => this.checkboxes.rows[item[this.checkboxes.rowID]]).length;
            this.checkboxes.disabled = this.checkboxes.masterChecked && this.checkboxes.checkedCounter != this.parentController.dataList.length;
        };

        // Watch for data checkboxes
        $scope.$watch(() => this.parentController.dataList, () => this.updateMasterCheckBox(), true); // when a page is loaded
        $scope.$watch(() => this.checkboxes.rows, () => this.updateMasterCheckBox(), true); // when manual selection
    }

    // Callback when the master check box is clicked
    checkAll() {
        this.selectAll(this.checkboxes.checkedCounter == 0);

        // As the master check box has no ng-model, form $pristine/$dirty attribute is not updated
        // that's why we broadcast the change
        this.$rootScope.$broadcast('master-check-box-fired');
    }

    selectAll(select) {
        this.checkboxes.masterChecked = select;
        this.parentController.dataList.forEach(
            (item) => this.checkboxes.rows[item[this.checkboxes.rowID]] = this.checkboxes.masterChecked);
    }

    selectType(type) {
        if (type === SELECT_ALL_TYPE.GLOBAL) {
            this.confirm(type);
        }

        this.checkboxes.rows = {}; // reinitializing the selectio
        this.selectAll(true);
        this.checkboxes.selectType = type;

        this.$rootScope.$broadcast('master-check-box-fired'); // for form update
    }

    confirm(type) {
        const confBean = new ConfirmationModalBean(this.parentController.translate.instant('SELECT_ALL_CONFIRMATION',
            { rowsCounter: this.parentController.total}), "SELECT_ALL", this.modal);

        this.parentController.modal.show({
            templateUrl: 'app/components/modal/confirmation-modal.html',
            controller: 'ConfirmationModalController',
            controllerAs: 'confirmationModalController',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true,
            resolve: { confirmationModalBean: () => confBean }
        }).then(() => {
            this.checkboxes.rows = {}; // reinitializing the selection
            this.selectAll(true);
            this.checkboxes.selectType = type;
            this.$rootScope.$broadcast('master-check-box-fired'); // for form update
        });

        this.checkboxes.selectType = SELECT_ALL_TYPE.PAGE;
    }
}
